<template>
<div class="home">
    <Navbar/>
    <NavbarCategory/>
    <b-container class="bv-example-row mb-3 mt-1">
      <b-row cols="4">
        <div v-for="product in products" :key="product.id">
          <Card :product="product"/>
        </div>
      </b-row>
    </b-container>
</div>
</template>

<script>
import Card from '../components/Card'
import Navbar from '@/components/Navbar.vue'
import NavbarCategory from '@/components/NavbarCategory.vue'

export default {
  name: 'ByCategory',
  components: {
    Card, Navbar, NavbarCategory
  },
  computed: {
    products () {
      return this.$store.state.productsByCategory
    }
  }
}
</script>

<style>

</style>
